import {PolymerElement, html} from '@polymer/polymer';
import {PanelDynamicRegionBehavior} from '../behaviors/panel-dynamic-region-behavior.js';
import {FieldcontainerSharedStylesHTML} from '../shared-styles/field-container.js';

class KeliPanelFields extends PanelDynamicRegionBehavior(PolymerElement) {
  static get template() {
    return html`
${FieldcontainerSharedStylesHTML}
<style>
  :host {
    position: relative;
    padding: 15px 20px 30px 20px;
    display: none;
    overflow-x: hidden;
    box-sizing: border-box;
    flex: 1;
  }

  :host(.visible) {
    display: block;
  }

  ::slotted(.block-panel-element) {
    margin: 0 0 .8em 0;
    min-width: 0; /* Gives a definite min size for grid layouts */
  }

  ::slotted(.block-panel-element:first-child) {
    margin-top: 0;
  }

  ::slotted(keli-banner.block-panel-element) {
    width: calc(100% + 40px);
    margin-left: -20px;
    padding-right: 20px;
    padding-left: 20px;
    box-sizing: border-box;
  }
</style>

<slot></slot>`;
  }

  static get is() {
    return 'keli-panel-fields';
  }

  connectedCallback() {
    super.connectedCallback();
    this.addEventListener('scroll', this.handleScroll);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll(event) {
    this.dispatchEvent(new CustomEvent('scrollElement', {
      bubbles: true,
      composed: true,
      detail: {event}
    }));
  }

  handleRegionVisibilityChanged(newValue) {
    this.classList.toggle('visible', newValue);
  }
}

customElements.define(KeliPanelFields.is, KeliPanelFields);
export {KeliPanelFields};
